import React from "react";
import WhatsappIcon from "lib/assets/svg/whatsapp";
import { officeContactDetails } from "config/config";
import "./whatsapp-float.css";

const WhatsappFloat = () => {
  const contact = officeContactDetails[0] || {};
  const rawPhone = (contact.phone || "+91 98423 93234").replace(/[^0-9]/g, "");

  // Custom message when user clicks "Talk to Kalyanawaran"
  const message = encodeURIComponent(
    "Hi Kalyanawaran Team, I would like to talk to you regarding matrimonial services and membership details."
  );

  // Requirement: Onclick of icon trigger the whatsapp message using api.whatsapp.com/send?phone=91{phone_number}&text=...
  const whatsappUrl = `https://api.whatsapp.com/send?phone=${rawPhone}&text=${message}`;

  return (
    <div className="whatsapp-float-container" id="talk-to-kalyanawaran-wrapper">
      <div className="whatsapp-float-pulse" />
      <a
        id="talk-to-kalyanawaran-btn"
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-float-btn"
        title="Talk to Kalyanawaran on WhatsApp"
      >
        <span className="whatsapp-icon-wrapper">
          <WhatsappIcon />
        </span>
        <span className="whatsapp-float-text">Talk to Kalyanawaran</span>
      </a>
    </div>
  );
};

export default WhatsappFloat;
